<template>
  <div>

    <div class="table-responsive">
      <h2>Текущий баланс</h2>
      <table class="table is-bordered currentBalance">
        <thead>
        <tr>
          <th>Ресурс</th>
          <th>Значение</th>
        </tr>
        </thead>
        <tbody>
        <tr
          v-for="(value, name) in clientBalance.balance"
          :key="name"
        >
          <td>{{ name }}</td>
          <td>{{ value }}</td>
        </tr>
        </tbody>
      </table>
    </div>

    <div
      class="table-responsive"
      v-if="replenishBalance"
    >
      <h2> Пополнить баланс </h2>
      <table class="table is-bordered is-striped is-narrow">
        <thead>
        <tr>
          <th>Ресурс</th>
          <th>Пополняемое значение</th>
        </tr>
        </thead>

        <tbody>
        <tr
          v-for="(value, name) in replenishBalance"
          :key="name"
        >
          <td> {{ name }}</td>
          <td>
            <input
              v-model.number="replenishBalance[name]"
              class="input"
              placeholder="0"
              type="number"
            >
          </td>
        </tr>
        </tbody>

      </table>

      <p class="control">
        <button
          class="button is-primary"
          v-on:click="replenishBalanceMethod()"
          :disabled="!!loading"
        >
          <span class="icon">
            <i class="fa fa-floppy-o"></i>
          </span>
          <span>Пополнить баланс</span>
        </button>
      </p>
    </div>

    <div class="table-responsive">
      <h2> Кредитный лимит </h2>
      <table class="table is-bordered is-striped is-narrow">
        <thead>
        <tr>
          <th>Ресурс</th>
          <th>Значение</th>
        </tr>
        </thead>

        <tbody>
        <tr
          v-for="(value, name) in clientBalance.creditLimit"
          :key="name"
        >
          <td> {{ name }}</td>
          <td>
            <input
              v-model.number="clientBalance.creditLimit[name]"
              class="input"
              placeholder="0"
              type="number"
            >
          </td>
        </tr>
        </tbody>

      </table>

      <p class="control">
        <button
          class="button is-primary"
          v-on:click="saveCreditLimit()"
          :disabled="!!loading"
        >
          <span class="icon">
            <i class="fa fa-floppy-o"></i>
          </span>
          <span>Обновить кредитный лимит</span>
        </button>
      </p>
    </div>

    <div
      class="table-responsive"
      v-if="addResourcePage && addResourcePage.content"
    >
      <label class="label addLabel">Пополнения</label>
      <table class="table is-bordered is-striped is-narrow campaignsTable">
        <thead>
        <tr>
          <th>
            <div
              :class="sortButtonClass('timestampUtcMillis', 'asc')"
              class="sortButton"
              @click="changeSort('timestampUtcMillis', 'asc')"
            >{{ ascIcon }}
            </div>
            <div
              :class="sortButtonClass('timestampUtcMillis', 'desc')"
              class="sortButton"
              @click="changeSort('timestampUtcMillis', 'desc')"
            >{{ descIcon }}
            </div>
            дата
          </th>
          <th>
            <div
              :class="sortButtonClass('totalResourcesValueLong', 'asc')"
              class="sortButton"
              @click="changeSort('totalResourcesValueLong', 'asc')"
            >{{ ascIcon }}
            </div>
            <div
              :class="sortButtonClass('totalResourcesValueLong', 'desc')"
              class="sortButton"
              @click="changeSort('totalResourcesValueLong', 'desc')"
            >{{ descIcon }}
            </div>
            Пополняемые ресурсы
          </th>
        </tr>
        </thead>
        <tbody>
        <tr
          v-for="(addResource) in addResourcePage.content"
          :key="addResource.id"
        >
          <td class="date">
            {{
              getDateFormat((addResource.timestampUtcMillis / 1000) < 1000000000000 ? addResource.timestampUtcMillis : addResource.timestamp / 1000)
            }}
          </td>
          <td>
            <div class="table-responsive">
              <table class="table is-bordered currentBalance">
                <thead>
                <tr>
                  <th>Ресурс</th>
                  <th>Значение</th>
                </tr>
                </thead>
                <tbody>
                <tr
                  v-for="(value, name) in addResource.resources"
                  :key="name"
                >
                  <td>{{ name }}</td>
                  <td>{{ value }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="paging-bottom">
      <Paging
        :refresh="loadAddResourcesData"
        :per-page="perPage"
        :data.sync="addResourcePage"
        :pagingClass="'bottom'"
      />
    </div>
  </div>
</template>

<script>
const BILLING_API = 'billing/'

import Paging from '../components/Paging'
import VisCommon from '../components/VisCommon'

export default {
  name: 'Balance',
  extends: VisCommon,
  components: {
    Paging
  },
  props: ['clientId', 'reloadClient', 'clientBalance'],
  data() {
    return {
      addResourcePage: {content: []},
      perPage: 8,
      title: '',
      replenishBalance: {},
      ivoiceResources: [],
      creditLimit: this.clientBalance.creditLimit,
      loading: false,
      currentSort: 'timestampUtcMillis',
      currentSortDir: 'desc',
      ascIcon: ' ▲',
      descIcon: ' ▼'
    }
  },
  created: function () {
    this.loadIvoiceResources()
    this.loadAddResourcesData()
  },
  methods: {
    loadAddResourcesData(page) {
      let that = this
      this.loading = true
      page = page ? (page - 1) : 0
      let url = BILLING_API + 'clientBalance/getAddResourcesList/' + this.$props.clientId + '?page=' + page + '&pageSize=' + this.perPage + '&sortDir=' + this.currentSortDir + '&sort=' + this.currentSort
      this.$http.get(url, {headers: this.prepareSecurityHeader()})
        .then((response) => {
          that.loading = false
          that.addResourcePage = response.data
        })
        .catch((error) => {
          that.loading = false
          console.log(error)
          that.openNotificationWithType('danger', 'Ошибка загрузки списка пополнений. ')
        })
    },
    loadIvoiceResources() {
      let that = this
      this.loading = true
      let url = BILLING_API + 'getBillingConfig/'
      this.$http.get(url, {headers: this.prepareSecurityHeader()})
        .then((response) => {
          that.loading = false
          const initialReplenishBalance = {}
          response.data.response.ivoiceResources.map(function (resource) {
            initialReplenishBalance[resource.name] = 0
            that.ivoiceResources.push(resource.name)
          })
          that.replenishBalance = initialReplenishBalance
        })
        .catch((error) => {
          that.loading = false
          console.log(error)
          that.openNotificationWithType('danger', 'Ошибка загрузки списка ресурсов Ivoice. ')
        })
    },
    changeSort(s, dir) {
      if (!this.isSortCurrent(s, dir)) {
        this.currentSort = s
        this.currentSortDir = dir
        this.loadAddResourcesData()
      }
    },
    sortButtonClass(s, dir) {
      return this.isSortCurrent(s, dir) ? 'current' : ''
    },
    isSortCurrent(s, dir) {
      return s === this.currentSort && dir === this.currentSortDir
    },

    replenishBalanceMethod() {
      let that = this
      this.loading = true
      let url = BILLING_API + 'clientBalance/addResources/' + this.$props.clientId
      this.$http.post(url, this.replenishBalance, {headers: this.prepareSecurityHeader()})
        .then((response) => {
          that.loading = false
          that.replenishBalance = {}
          that.ivoiceResources.forEach(function (item) {
            that.replenishBalance[item] = 0
          })
          that.openNotificationWithType('info', 'Баланс успешно пополнен')
          that.$props.reloadClient()
          that.loadAddResourcesData()
        })
        .catch((error) => {
          if (error.response && error.response.status != 200) {
            console.log(error.response.data)
          }
          that.loading = false
          that.openNotificationWithType('danger', 'Ошибка пополнения баланса, код ошибки: ' + error.response.data.code)
        })
    },

    saveCreditLimit() {
      let that = this
      this.loading = true
      let url = BILLING_API + 'clientBalance/updateCreditLimit/' + this.$props.clientId
      this.$http.post(url, this.creditLimit, {headers: this.prepareSecurityHeader()})
        .then((response) => {
          that.loading = false
          that.openNotificationWithType('info', 'Кредитный лимит успешно обновлён')
          that.$props.reloadClient()
          that.loadAddResourcesData()
        })
        .catch((error) => {
          if (error.response && error.response.status != 200) {
            console.log(error.response.data)
          }
          that.loading = false
          that.openNotificationWithType('danger', 'Ошибка обновления кредитного лимита, код ошибки: ' + error.response.data.code)
        })
    }
  }
}
</script>

<style scoped>
th div {
  display: inline-block;
}

th .sortButton {
  cursor: pointer;
}

th .sortButton:hover,
th .sortButton.current,
.total {
  font-weight: bold;
  font-size: large;
}

.addLabel {
  margin-bottom: -27px;
  margin-left: 4px;
  padding-top: 8px;
  width: 32px;
}

.currentBalance td {
  text-align: center;
}

.table-responsive h2 {
  text-align: center;
  font-weight: bold;
  font-size: large;
}

.control,
.resource {
  text-align: center;
}

.button.is-primary {
  width: 100%;
  height: 50px;
}
</style>




// WEBPACK FOOTER //
// Balance.vue?10e3f8e3